// Womens Bundle Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Fabian", location: "MI", product: "#1 Women's Bundle", time: "24 minutes ago" },
    { name: "Claudia", location: "TX", product: "#1 Women's Bundle", time: "50 minutes ago" },
    { name: "Diane", location: "GA", product: "#1 Women's Bundle", time: "1 hour 18 minutes ago" },
    { name: "Araceli", location: "IL", product: "#1 Women's Bundle", time: "1 hour 47 minutes ago" },
    { name: "Brenda", location: "LA", product: "#1 Women's Bundle", time: "2 hours 17 minutes ago" },
    { name: "Isabel", location: "IL", product: "#1 Women's Bundle", time: "2 hours 48 minutes ago" },
    { name: "Elizabeth", location: "NJ", product: "#1 Women's Bundle", time: "3 hours 20 minutes ago" },
    { name: "Lisa", location: "IL", product: "#1 Women's Bundle", time: "3 hours 53 minutes ago" },
    { name: "Gloria", location: "FL", product: "#1 Women's Bundle", time: "4 hours 27 minutes ago" },
    { name: "Genevieve", location: "NY", product: "#1 Women's Bundle", time: "5 hours 2 minutes ago" },
    { name: "Cherie", location: "NC", product: "#1 Women's Bundle", time: "27 minutes ago" },
    { name: "Alejandra", location: "TX", product: "#1 Women's Bundle", time: "53 minutes ago" },
    { name: "Cruz", location: "NV", product: "#1 Women's Bundle", time: "1 hour 21 minutes ago" },
    { name: "Patrice", location: "AL", product: "#1 Women's Bundle", time: "1 hour 50 minutes ago" },
    { name: "Ketsana", location: "TN", product: "#1 Women's Bundle", time: "2 hours 20 minutes ago" },
    { name: "Gregory", location: "NJ", product: "#1 Women's Bundle", time: "2 hours 51 minutes ago" },
    { name: "Deisy", location: "VA", product: "#1 Women's Bundle", time: "3 hours 23 minutes ago" },
    { name: "Tiffini", location: "TX", product: "#1 Women's Bundle", time: "3 hours 56 minutes ago" },
    { name: "Bridgette", location: "TX", product: "#1 Women's Bundle", time: "4 hours 30 minutes ago" },
    { name: "Virginia", location: "IL", product: "#1 Women's Bundle", time: "5 hours 5 minutes ago" },
    { name: "Tim", location: "CA", product: "#1 Women's Bundle", time: "29 minutes ago" },
    { name: "Jill", location: "FL", product: "#1 Women's Bundle", time: "57 minutes ago" },
    { name: "Connie", location: "FL", product: "#1 Women's Bundle", time: "1 hour 26 minutes ago" },
    { name: "Timothy", location: "NE", product: "#1 Women's Bundle", time: "1 hour 56 minutes ago" },
    { name: "Vicky", location: "FL", product: "#1 Women's Bundle", time: "2 hours 27 minutes ago" },
    { name: "Jamie", location: "PA", product: "#1 Women's Bundle", time: "2 hours 59 minutes ago" },
    { name: "Karla", location: "TX", product: "#1 Women's Bundle", time: "3 hours 32 minutes ago" },
    { name: "Maria", location: "CA", product: "#1 Women's Bundle", time: "4 hours 6 minutes ago" },
    { name: "Kim", location: "CA", product: "#1 Women's Bundle", time: "4 hours 41 minutes ago" },
    { name: "Joana", location: "CA", product: "#1 Women's Bundle", time: "5 hours 17 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/1_Womens_Bundle_No_Badge.png?v=1733787023" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
